// src/components/Footer.js
// src/components/Footer.js
import React from 'react';
import styles from './Footer.module.css';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Link } from 'react-router-dom';


const Footer = ({ isLoggedIn }) => {
  // const navigate = useNavigate();

  // const handleClick = () => {
  //   if (!isLoggedIn) {
  //     navigate('/login');
  //   }
  // };
  return (

      <footer className={styles.footer}>
      © {new Date().getFullYear()} BETA - Breakthrough Engineering and Technology Applications. All rights reserved. 
      {/* <div><Link to="/login" className={styles.stars}>★★★★★</Link></div> */}
      
      {/* <div className={styles.seoLinks}>
        <Link to="/best-software-company-in-india">
          Best Software Company in India
        </Link>
      </div> */}
      
      <div className={styles.stars}>★★★★★</div>
      </footer>
    );





  // return (
  //   isLoggedIn ?
  //   <footer className={styles.footer}>
  //   © {new Date().getFullYear()} BETA - Breakthrough Engineering and Technology Applications. All rights reserved.
  //   </footer>
  //   : 
  //   <footer onClick={handleClick} className={styles.footer}>
  //   © {new Date().getFullYear()} BETA - Breakthrough Engineering and Technology Applications. All rights reserved. 
  //   {/* <div><Link to="/login" className={styles.stars}>★★★★★</Link></div> */}
  //   <div className={styles.stars}>★★★★★</div>
  //   </footer>
  // );
};

export default Footer;






// import React from 'react';
// import styles from './Footer.module.css';

// const Footer = () => {
//   return (
//     <footer className={styles.footer}>
//       © {new Date().getFullYear()} BETA - Breakthrough Engineering and Technology Applications. All rights reserved.
//     </footer>
//   );
// };

// export default Footer;
